module.exports = ":host /deep/ .simple-notification .icon svg{\r\n    height: 56% !important\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main